import { render, staticRenderFns } from "./arviointityokalut.vue?vue&type=template&id=793b9368&scoped=true&"
import script from "./arviointityokalut.vue?vue&type=script&lang=ts&"
export * from "./arviointityokalut.vue?vue&type=script&lang=ts&"
import style0 from "./arviointityokalut.vue?vue&type=style&index=0&id=793b9368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793b9368",
  null
  
)

export default component.exports